import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    DeliveryServiceType,
    CollectionServiceTypeSimplifiedCQuote,
} from 'app/enums/label.enums'
import {
    SimplifiedCQuoteCreateType,
} from '../../simplifiedCQuoteCreate.types'

const getFields = ({
    getAllowedValues,
    disabledDeliveryServiceType,
    disabledCollectionServiceType,
    disabled,
}: {
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    disabledDeliveryServiceType: boolean,
    disabledCollectionServiceType: boolean,
    disabled: boolean,
}): DTOCardFormField<keyof SimplifiedCQuoteCreateType>[] => {
    return [{
        id: 'deliveryOptions',
        title: 'Delivery Options',
        className: 'deliveryOptions',
        fields: [
            {
                id: 'deliveryOptions-column1',
                fields: [{
                    name: 'deliveryServiceType',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(DeliveryServiceType),
                    required: true,
                    showInColumns: true,
                    disabled: disabledDeliveryServiceType || disabled,
                    labelKey: 'LaneGroup.deliveryServiceType',
                }],
            },
            {
                id: 'deliveryOptions-column2',
                fields: [{
                    name: 'collectionServiceType',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(CollectionServiceTypeSimplifiedCQuote),
                    showInColumns: true,
                    required: true,
                    disabled: disabledCollectionServiceType || disabled,
                    labelKey: 'LaneGroup.collectionServiceType',
                }],
            },
        ],
    }]
}

export default getFields
